import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import './index.css'
import { ConfigProvider } from 'antd';

// 使用标准的 React 18 渲染方法
ReactDOM.createRoot(document.getElementById('root')!).render(
    <>
        <ConfigProvider locale={zhCN} >
            <App />
        </ConfigProvider>
    </>
)
